<template>
    <div class="groups-card">
        <!-- Header -->
        <div class="groups-header cursor-pointer transition-opacity duration-200 hover:opacity-80"
            @click="navigateToGroups">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M0 18V16.425C0 15.7083 0.366667 15.125 1.1 14.675C1.83333 14.225 2.8 14 4 14C4.21667 14 4.425 14.0043 4.625 14.013C4.825 14.0217 5.01667 14.0423 5.2 14.075C4.96667 14.425 4.79167 14.7917 4.675 15.175C4.55833 15.5583 4.5 15.9583 4.5 16.375V18H0ZM6 18V16.375C6 15.8417 6.146 15.354 6.438 14.912C6.73 14.47 7.14233 14.0827 7.675 13.75C8.20767 13.4173 8.84533 13.1673 9.588 13C10.3307 12.8327 11.1347 12.7493 12 12.75C12.8833 12.75 13.696 12.8333 14.438 13C15.18 13.1667 15.8173 13.4167 16.35 13.75C16.8827 14.0833 17.291 14.471 17.575 14.913C17.859 15.355 18.0007 15.8423 18 16.375V18H6ZM19.5 18V16.375C19.5 15.9417 19.446 15.5333 19.338 15.15C19.23 14.7667 19.0673 14.4083 18.85 14.075C19.0333 14.0417 19.221 14.021 19.413 14.013C19.605 14.005 19.8007 14.0007 20 14C21.2 14 22.1667 14.221 22.9 14.663C23.6333 15.105 24 15.6923 24 16.425V18H19.5ZM4 13C3.45 13 2.97933 12.8043 2.588 12.413C2.19667 12.0217 2.00067 11.5507 2 11C2 10.4333 2.196 9.95833 2.588 9.575C2.98 9.19167 3.45067 9 4 9C4.56667 9 5.04167 9.19167 5.425 9.575C5.80833 9.95833 6 10.4333 6 11C6 11.55 5.80833 12.021 5.425 12.413C5.04167 12.805 4.56667 13.0007 4 13ZM20 13C19.45 13 18.9793 12.8043 18.588 12.413C18.1967 12.0217 18.0007 11.5507 18 11C18 10.4333 18.196 9.95833 18.588 9.575C18.98 9.19167 19.4507 9 20 9C20.5667 9 21.0417 9.19167 21.425 9.575C21.8083 9.95833 22 10.4333 22 11C22 11.55 21.8083 12.021 21.425 12.413C21.0417 12.805 20.5667 13.0007 20 13ZM12 12C11.1667 12 10.4583 11.7083 9.875 11.125C9.29167 10.5417 9 9.83333 9 9C9 8.15 9.29167 7.43767 9.875 6.863C10.4583 6.28833 11.1667 6.00067 12 6C12.85 6 13.5627 6.28767 14.138 6.863C14.7133 7.43833 15.0007 8.15067 15 9C15 9.83333 14.7127 10.5417 14.138 11.125C13.5633 11.7083 12.8507 12 12 12Z"
                    fill="white" />
            </svg>

            <h2 class="groups-title" @click="navigateToGroups">Groups</h2>
            <i class="pi pi-external-link text-white"></i>
        </div>
        <div v-if="limitedGroups.length > 0">
            <!-- Group list
            <div> -->
            <div v-for="group in limitedGroups" :key="group.name" class="group-item">
                <!-- <img :src="group.avatarFileId" alt="group avatar" class="group-avatar" /> -->
                <img :src="group?.avatarFile ? BaseURL + group?.avatarFile?.storageId : defaultImage" alt="group avatar"
                    class="group-avatar" />
                <!-- <img src="/images/DefaultAvatar.svg" alt="group avatar" class="group-avatar" /> -->
                <div class="group-info">
                    <router-link :to="`/group/${group.id}`"
                        class="text-[var(--foreground-primary)] hover:underline text-[0.9rem] font-semibold title">{{
                            group.name
                        }}</router-link>
                    <!-- <p class="group-name">{{ group.name }}</p> -->
                    <p class="group-category"> {{ getUserRole(group) || 'Member' }}</p>
                </div>
                <div class="group-followers">
                    <span class="online-dot"></span>
                    <span class="followers-count">{{ group.members.length }}</span>
                </div>
            </div>
        </div>
        <div v-if="limitedGroups.length === 0">
            <p class="groups-subtitle">No any group found!</p>
        </div>
        <!-- </div> -->
    </div>
</template>

<script setup lang="ts">
import { computed, defineProps, PropType, watch } from "vue";
import { useRouter } from "vue-router";
import { BaseURL } from "@/global/baseUrls";
import defaultImage from "@/assets/images/DefaultAvatar.svg"
const user = JSON.parse(localStorage.getItem("user"));
console.error("user---------", user);
const router = useRouter();

const props = defineProps({
    groupsData: {
        type: Array as PropType<Group[]>,
        required: true
    }
});
// Define the type for the group data
interface Group {
    avatarFile: any;
    name: string;
    avatarFileId: string;
    ownerType: string;
    username: string;
    members: any[];
    id: string;
}
// Show only first 4
const limitedGroups = computed(() => props.groupsData.slice(0, 4));
// console.error("FollowedGroups groupsData:", limitedGroups[0].avatarFileId);
const getUserRole = (group: Group) => {
    const member = group.members.find((m) => m.userId === user?.id);
    return member ? member.role : null;
};
const navigateToGroups = () => {
    router.push('/groups');
};
watch(
    () => props.groupsData,
    (val) => {

    },
    { immediate: true }
);
</script>

<style scoped>
.groups-card {
    background: var(--header-bg-light);
    border-radius: 10px;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
    padding: 30px 12px 12px 12px;
    /* ✅ use spaces, not commas */
    width: 100%;
    border: 1px solid #f1f1f1;
    margin-top: 1rem;
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    border: 1px solid var(--border-leftbar-component);

    position: relative;
}

/* Header section */
.groups-header {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: -13px;
    left: 0px;
    display: flex;
    background-color: var(--container-head);
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;
    padding: 0.4rem;
    /* border-bottom: 1px solid #e5e7eb; */
    border-top-left-radius: 8px;
    border-top-right-radius: 8px;
    width: 100%;
    cursor: pointer;
    transition: all 0.2s ease;
}

.groups-icon {
    width: 20px;
    height: 20px;
    color: #2563eb;
    /* blue-600 */
}

.groups-title {
    font-size: 18px;
    font-weight: 600;
    color: white;
}

.groups-subtitle {
    margin-top: 12px;
    color: var(--text-black-white);
    font-size: 14px;
    margin-bottom: 12px;
    font-weight: 600
}

/* Each group item */
.group-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    border-bottom: 1px solid var(--border-leftbar-transparent);

}

.group-item:last-child {
    margin-bottom: 0;
}

/* Group avatar */
.group-avatar {
    width: 2rem;
    height: 2rem;
    border-radius: 1.5rem;
    object-fit: cover;
    border: 1px solid #d1d5db;
}

/* Group info text */
.group-info {
    margin-left: 12px;
    flex: 1;
}

.group-name {
    font-size: 12px;
    font-weight: 600;
    color: var(--text-black-white);
    cursor: pointer;
    font-weight: 600;
}

.group-name:hover {
    text-decoration: underline;
}

.group-category {
    font-size: 12px;
    color: #4849A1;
    font-weight: 600;
}

/* Follower count */
.group-followers {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 12px;
    color: #374151;
}

.online-dot {
    width: 8px;
    height: 8px;
    background-color: var(--dote);
    border-radius: 50%;
}

.followers-count {
    font-weight: 700;

}
</style>
